import { AnalyticsDataSource, MetadataCloud, TimeInterval } from "@doitintl/cmp-models";

import { type MetadataOption } from "../../../../types";

export const HIDDEN_METADATA: Partial<Record<AnalyticsDataSource, string[]>> = {
  [AnalyticsDataSource.KUBERNETES_UTILIZATION]: ["fixed:percentile"],
};

export const filterMetadataOption = (metadata: MetadataOption | undefined): boolean => {
  const customFilters = metadata?.dataSource ? HIDDEN_METADATA[metadata?.dataSource] : [];
  if (metadata && customFilters?.length) {
    return !customFilters?.includes(metadata?.id);
  }

  return true;
};

export const CLOUD_PROVIDER_TIME_INTERVAL_EXCLUSIONS: Partial<Record<MetadataCloud, TimeInterval[]>> = {
  [MetadataCloud.CLOUDZERO]: [TimeInterval.HOUR],
} as const;

export const getExcludedIntervals = (cloudProviderInclusions: Partial<Record<MetadataCloud, boolean>>) => {
  const excluded = new Set<TimeInterval>();
  if (cloudProviderInclusions) {
    Object.entries(cloudProviderInclusions).forEach(([provider, isEnabled]) => {
      if (isEnabled && CLOUD_PROVIDER_TIME_INTERVAL_EXCLUSIONS[provider]) {
        CLOUD_PROVIDER_TIME_INTERVAL_EXCLUSIONS[provider]!.forEach((interval) => {
          excluded.add(interval);
        });
      }
    });
  }
  return excluded;
};
